<!-- Edit Company Data [Drawer]-->
<div class="app-space-top app-space-right">
	<ng-container *ngIf="showCompanyForm">
		<div class="layout-auto-1">
			<h2>
				<i class="fal fa-building"></i>
				{{getGlobal('Company')}}
				<ng-container *ngIf="init">
					{{getGlobal('create')}}
				</ng-container>
				<ng-container *ngIf="!init">
					{{getGlobal('edit')}}
				</ng-container>
				<ng-container *ngIf="CompanyDataClone.compDEL">
					{{'[' + getGlobal('deleted') + ']'}}
				</ng-container>
			</h2>
			<div class="content">
				<form #VCcompanyForm="ngForm" name="companyForm">
					<div class="grid cols-6">
						<exg-textarea #compName [minlength]="1"
						              [required]="CompanyDataClone.compName.length === 0"
						              [hintText]="CompanyDataClone.compName.length === 0 ? getRessource('Pflichtangabe') : ''"
							            [(ngModel)]="CompanyDataClone.compName"
							            [caption]="enumSvc.getFieldCaption('Company','compName')"
							            class="span-6"
							            name="compName">
						</exg-textarea>
						<exg-input #compAdressline1
						           [(ngModel)]="CompanyDataClone.compAdressline1"
						           [caption]="enumSvc.getFieldCaption('Company','compAdressline1')"
						           class="span-6"
						           name="compAdressline1">
						</exg-input>
						<exg-input #compAdressline2
						           [(ngModel)]="CompanyDataClone.compAdressline2"
						           [caption]="enumSvc.getFieldCaption('Company','compAdressline2')"
						           class="span-6"
						           name="compAdressline2">
						</exg-input>
            <exg-select #compCountry
                        [(ngModel)]="CompanyDataClone.compCountry"
                        [caption]="enumSvc.getFieldCaption('Company','compCountry')"
                        [list]="countryList"
                        listdisplay="enmText"
                        listvalue="enmTextA"
                        name="compCountry"
                        class="span-2 ">
            </exg-select>
						<exg-input #compZip
						           [(ngModel)]="CompanyDataClone.compZip"
						           [caption]="enumSvc.getFieldCaption('Company','compZip')"
						           class=""
						           name="compZip">
						</exg-input>
						<exg-input #compLocation
						           [(ngModel)]="CompanyDataClone.compLocation"
						           [caption]="enumSvc.getFieldCaption('Company','compLocation')"
						           class="span-3"
						           name="compLocation">
						</exg-input>
						<exg-input #compContactMail
						           [(ngModel)]="CompanyDataClone.compContactMail"
						           [caption]="enumSvc.getFieldCaption('Company','compContactMail')"
						           class="span-3"
						           name="compContactMail">
						</exg-input>
						<exg-input #compContactNumber
						           [(ngModel)]="CompanyDataClone.compContactNumber"
						           [caption]="enumSvc.getFieldCaption('Company','compContactNumber')"
						           class="span-3"
						           name="compContactNumber">
						</exg-input>
						<exg-input #compWebsite
						           [(ngModel)]="CompanyDataClone.compWebsite"
						           [caption]="enumSvc.getFieldCaption('Company','compWebsite')"
						           class="span-6"
						           name="compWebsite">
						</exg-input>
						<exg-input #compSalesTaxID [minlength]="1"
						           [required]="!validateTaxIDs()"
						           [hintText]="!validateTaxIDs() ? getRessource('Pflichtangabe') : ''"
						           [(ngModel)]="CompanyDataClone.compSalesTaxID"
						           [caption]="enumSvc.getFieldCaption('Company','compSalesTaxID')"
						           class="span-3"
						           name="compSalesTaxID"
						           (focusout)="checkDuplicates()">
						</exg-input>
						<exg-input #compTaxID [minlength]="1"
						           [required]="!validateTaxIDs()"
						           [hintText]="!validateTaxIDs() ? getRessource('Pflichtangabe') : ''"
						           [(ngModel)]="CompanyDataClone.compTaxID"
						           [caption]="enumSvc.getFieldCaption('Company','compTaxID')"
						           class="span-3"
						           name="compTaxID"
						           (focusout)="checkDuplicates()">
						</exg-input>
						<div class="span-3"></div>
						<exg-input #compRegisterNo
						           [(ngModel)]="CompanyDataClone.compRegisterNo"
						           [caption]="enumSvc.getFieldCaption('Company','compRegisterNo')"
						           class="span-3"
						           name="compRegisterNo">
						</exg-input>
					</div>
				</form>
				<p *ngIf="init && duplicate" style="text-align: right;" class=" typo-small c-red">
					{{getRessource('duplicate')}}
				</p>
			</div>
		</div>
	</ng-container>
	<!-- Show Company Data -->
	<ng-container *ngIf="!showCompanyForm">
		<div class="typo-container-s-s-q">
      <span class="typo-small app-space-left">
        {{enumSvc.getFieldCaption('Receipt', 'rcptComp')}}:
      </span>
			<span class="typo-small"><strong>{{CompanyData?.compName}}</strong></span>
			<q></q>
			<ng-container *ngIf="(CompanyData?.compAdressline1 + CompanyData?.compAdressline2).length > 1">
				<span></span>
				<span class="typo-small">{{CompanyData?.compAdressline1}}</span>
				<q></q>
				<span></span>
				<span class="typo-small">{{CompanyData?.compAdressline2}}</span>
				<q></q>
			</ng-container>
			<ng-container *ngIf="(CompanyData?.compCountry + CompanyData?.compZip + CompanyData?.compLocation).length > 1">
				<span></span>
				<span class="typo-small">
          {{ isNumberString(CompanyData?.compCountry) ? enumSvc.getEnumerationTextA('Country', CompanyData?.compCountry) : CompanyData?.compCountry }} {{ CompanyData?.compZip }} {{ CompanyData?.compLocation}}
        </span>
				<q></q>
			</ng-container>
		</div>
	</ng-container>
</div>
